import MUITh from '@mui/material/TableCell';
import React from 'react';

import { tableMapper } from '~/common/components/PropertyMappers/tableMapper';

type ThProps = React.ComponentProps<typeof MUITh>;

const Th = React.forwardRef<any, ThProps>(({ children, ...props }, ref) => {
  const tableProps = tableMapper(props);
  return (
    <MUITh scope="row" component="th" ref={ref} {...tableProps}>
      {children}
    </MUITh>
  );
});

Th.displayName = 'Th';

export default Th;
